import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormComponent } from "./dynamic-form.component";
import { DynamicFormFieldComponent } from "./dynamic-form-field.component";
import { CommonModule } from "@angular/common";
import { MyDatePickerModule } from "mydatepicker";
import { PreventKeysDirective } from "../admin/prevent-keys.directive";
import { NguiAutoCompleteModule } from "@ngui/auto-complete";

@NgModule({
    declarations: [
        DynamicFormComponent,
        DynamicFormFieldComponent,
        PreventKeysDirective
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MyDatePickerModule,
        NguiAutoCompleteModule
    ],
    exports: [
        DynamicFormComponent,
        PreventKeysDirective
    ]
})
export class DynamicFormModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/dynamic-form.module.ts